<template>
    <span style="display: inline-block;">
        <el-upload
            ref="upload"
            :action="action"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :data="uploadData"
            :on-success="uploadCallback"
            :on-error="errorCallback"
            style="display: inline-block;"
            :disabled="disabled"
            :accept="accept"
        >
            <el-button
                :type="type"
                :size="size"
                :disabled="disabled"
                @click="$emit('uploadClick')"
            >{{ uploadText }}</el-button>
        </el-upload>
        <a
            class="btn-download-file"
            v-if="downloadUrl"
            target="_blank"
            :href="downloadUrl"
            :download="downloadFileName || downloadUrl"
            @click="$emit('downloadClick')"
        >{{ downloadText }}</a>
        <a
            class="btn-download-file"
            v-if="remoteDownloadUrl"
            target="_blank"
            :href="remoteDownloadUrl"
            :download="downloadFileName || remoteDownloadUrl"
            @click="$emit('downloadClick')"
        >{{ downloadText }}</a>
    </span>
</template>

<script>
/**
 *
 * @author fangtao04
 * @since 1.3.2
 *
 * 文件上传组件，默认将文件上传到美团云上
 *
 */
export default {
    name: 'XxFileUpload',
    props: {
        /**
         *  bucketName, 文件需要存放在的地方，这个应该有一个默认值，联系方涛解决
         */
        bucketName: {
            type: String,
            required: true
        },
        /**
         *  uploadText, 上传文件按钮的文案
         */
        uploadText: {
            type: String,
            default: '上传文件'
        },
        /**
         *  文件名生成函数，这个应该有一个默认值，联系方涛解决
         *  通常情况下，不能按照文件的原始名称上传，主要是考虑到文件覆盖问题
         */
        generateFileName: {
            type: Function
        },
        /**
         * exts Array, 为文件的扩展名信息
         * size Number, 为文件必须符合的大小
         * */
        rules: {
            type: Object,
            default: () => {
                return null;
            }
        },
        /**
         *  上传成功之后的回掉，参数是上传成功后的文件名
         */

        onSuccess: {
            type: Function
        },
        /**
         *  不知道做什么的，需要方涛补充
         */
        onBefore: {
            type: Function
        },
        /**
         *  不知道做什么的，需要方涛补充
         */
        disabled: {
            type: Boolean,
            default: false
        },
        /**
         *  上传按钮的样式，默认是primary
         */
        type: {
            type: String,
            default: 'primary'
        },
        /**
         *  上传按钮的大小，默认是small
         */
        size: {
            type: String,
            default: 'small'
        },
        /**
         *  不知道做什么的，需要方涛补充
         */
        downloadUrl: {
            type: String,
            default: ''
        },
        /**
         *  不知道做什么的，需要方涛补充
         */
        downloadFileName: {
            type: String,
            default: ''
        },
        /**
         *  不知道做什么的，需要方涛补充
         */
        downloadText: {
            type: String,
            default: '下载模板'
        },
        /**
         *配置到Portm上的key
         *配置链接如下 http://portm.sankuai.com/page/portm-horn/index.html#/file?rootId=539d2f71-8601-4c9c-bd8d-efa528571321&action=modify&env=dev
         */
        remotePortmKey: {
            type: String,
            default: ''
        },
        /**
         *远端配置的下载模板的名字
         */
        remoteUrlkey: {
            type: String,
            default: ''
        },
        accept: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            action: `${window.location.origin}/kit/mss/upload`,
            uploadData: {},
            lock: false,
            remoteDownloadUrl: ''
        };
    },
    async created() {
        // 区分线上线下环境的模板配置地址
        // 线上配置地址 http://portm.sankuai.com/page/portm-horn/index.html#/file?rootId=539d2f71-8601-4c9c-bd8d-efa528571321&action=modify&env=dev
        // 线下配置地址 http://portm.sankuai.com/page/portm-horn/index.html#/file?rootId=cd5ae2ca-880e-45bb-af28-3320e324f499&action=modify&env=dev
        const isProd = ['staging', 'production'].includes(process.env.NODE_ENV);
        const urlDataKey = isProd ? 'jiemo_xx_upload_template' : 'jiemo_xx_upload_template_test';
        if (this.remotePortmKey) {
            const urls = await this.$tools.fetchPortal(`${urlDataKey}`)(`${this.remotePortmKey}`);
            this.remoteDownloadUrl = urls[this.remoteUrlkey] || '';
        }
        this.uploadData.bucketName = this.bucketName;
    },
    mounted() {},
    methods: {
        beforeUpload(file) {
            return new Promise((res, rej) => {
                if (this.lock) {
                    rej();
                }

                if (this.rules) {
                    let msg;
                    if (
                        Array.isArray(this.rules.exts) &&
                        !this.rules.exts.some(ext => {
                            return new RegExp(`\\.${ext}$`).test(file.name);
                        })
                    ) {
                        msg = '上传文件格式错误';
                    }
                    if (this.rules.size && file.size > this.rules.size) {
                        msg = '上传文件过大';
                    }
                    if (msg) {
                        this.$message({
                            type: 'error',
                            message: msg
                        });
                        rej();
                        return;
                    }
                }

                let splitArr = file.name.split('.'),
                    ext = splitArr[splitArr.length - 1];

                this.uploadData.fileName = this.generateFileName ? `${this.generateFileName(file)}.${ext}` : new Date().getTime() + file.name;
                this.lock = true;
                res();
            });
        },
        uploadCallback(response, file, fileList) {
            this.onSuccess && this.onSuccess(this.uploadData.fileName);
            this.lock = false;
        },
        errorCallback(err, file, fileList) {
            this.lock = false;
            this.$message({
                type: 'error',
                message: err.message || '上传文件出错'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.file-upload {
    position: relative;
    &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        cursor: pointer;
    }
}
.btn-download-file {
    color: #99a9bf;
    vertical-align: bottom;
    font-size: 12px;
}
</style>
